// Export all assets from a single location
// Assets are served from /portal_ti/assets/images/ (public folder)

const rawBasePath = (window.APP_CONFIG?.BASE_PATH || '/portal_ti');
const basePath = rawBasePath === '/' ? '' : rawBasePath;

// Todas las apps del holding usan el mismo logo (la estrella de HelpDesk)
// eslint-disable-next-line no-unused-vars
export const isotipoApp = (codigo) => `${basePath}/assets/apps/logo-app.png`;

export const Assets = {
    Logos: {
        Vicsa: `${basePath}/assets/images/Logo_Vicsa.png`,
        VicsaBunzl: `${basePath}/assets/images/Logo_Vicsa_Bunzl.png`,
        Tecnoboga: `${basePath}/assets/images/Logo_TECNOBOGA.png`,
        B2B: `${basePath}/assets/images/Logo_B2BWeb.png`,
        Bunzl: `${basePath}/assets/images/Logo_BUNZL.png`,
        DPS: `${basePath}/assets/images/Logo_DPS.png`,
        Hospitalia: `${basePath}/assets/images/Logo_Hospitalia.png`,
        Default: `${basePath}/assets/images/logo.png`,
    },
    Portals: {
        OneTrust: `${basePath}/assets/images/Portal_OneTrust.png`,
        KnowBe4: `${basePath}/assets/images/Portal_KnowBe4.png`,
    },
    Common: {
        Banner: `${basePath}/assets/images/banner_helpdesk.png`,
        Avatar: `${basePath}/assets/images/avatar.png`,
    }
};

// Helper para obtener logo por nombre de empresa (backward compatibility logic)
export const getLogoByCompanyName = (companyName) => {
    if (!companyName) return Assets.Logos.Default;

    const lowerName = companyName.toLowerCase().trim();

    if (lowerName.includes('vicsa')) return Assets.Logos.Vicsa;
    if (lowerName.includes('tecnoboga')) return Assets.Logos.Tecnoboga;
    if (lowerName.includes('b2b')) return Assets.Logos.B2B;
    if (lowerName.includes('bunzl')) return Assets.Logos.Bunzl;
    if (lowerName.includes('dps')) return Assets.Logos.DPS;
    if (lowerName.includes('hospitalia')) return Assets.Logos.Hospitalia;

    return Assets.Logos.Default;
};
